import React from "react";
import { Stylesilla } from "./style";
import { displayMesaNombre } from "utils/constantes";

// Plantilla "generica" que se usa cuando la cantidad de sillas de una mesa
// no calza con ninguna plantilla de tamaño fijo (2/4/6/8/10/11/12/13/14/15-20).
// Antes dibujaba SIEMPRE 12 sillas decorativas fijas, sin ninguna relacion
// con los datos reales -- por eso aparecian sillas que no existian en la
// base de datos (mesas con 1, 3, 5, 7 o 9 sillas reales, por ejemplo,
// mostraban igual 12). Ahora dibuja exactamente las sillas reales de
// "list", usando el codigo propio de cada silla (silla.silla) en vez de un
// nombre "mesa-s-N" inventado -- igual que ya hacen el mapa de filas
// (SillasView) y la app movil.
const MesacerView = ({ text, list, obtenerid, alert, succesSilla, Estado, MesaEstado, enviarsillas }) => {
  const sillas = list || []
  return (
    <div style={{ padding: '0.7px' }}>
      {alert}
      <div className="d-flex flex-wrap" style={{ maxWidth: 130 }}>
        {sillas.map((silla, index) => (
          <a key={index} id={obtenerid(silla.silla)}
            onClick={() => succesSilla(silla.silla)}
            className={silla.silla + " sillas  " + Estado(silla.silla)} style={Stylesilla.asientos}>
          </a>
        ))}
      </div>
      <div id={text} className={text + " " + sillas.length + " Mesa  txt-white d-flex p-1 " + MesaEstado(text)}
        onClick={() => enviarsillas(text)}
        style={Stylesilla.mesas}>
        {displayMesaNombre(text)}
      </div>
    </div>
  )

}

export default MesacerView;